import api from './../api';

export const foodServices = {
    getFoods: async (withResponse = false, defaultResponse = null) => {
        let response = await api
            .get('/foods')
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },

    getFood: async (food_id, withResponse = false, defaultResponse = null) => {
        let response = await api
            .get(`/food/${food_id}`)
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },
};
